import * as THREE from 'three';

// One-time device capability sniff → fewer animals on weaker hardware for a
// guaranteed-smooth first load. Force with ?low=1.
export const LOW_POWER = (() => {
  if (typeof navigator === 'undefined') return false;
  const forced = typeof window !== 'undefined' && new URLSearchParams(window.location.search).get('low') === '1';
  const cores = navigator.hardwareConcurrency || 8;
  const mem = navigator.deviceMemory || 8;
  const mobile = /Android|iPhone|iPad|iPod|Mobile/i.test(navigator.userAgent || '');
  return forced || cores <= 4 || mem <= 3 || mobile;
})();

// Mutable transforms shared between the Rig (writer) and 3D/audio actors (readers)
// without triggering React re-renders every frame.
export const shared = {
  lowPower: LOW_POWER,
  eagleTarget: new THREE.Vector3(0, 20, 40),
  lookTarget: new THREE.Vector3(0, 0, 0),
  eaglePos: new THREE.Vector3(0, 20, 40),

  // Live camera transform (for the binaural audio listener)
  camPos: new THREE.Vector3(0, 6, 44),
  camDir: new THREE.Vector3(0, 0, -1),

  // Environment state driven by WorldClock
  env: { dayTime: 0.32, night: 0, storm: 0 },
  forceStorm: false,

  // Merged navigation intent (keyboard + touch joystick)
  input: { forward: 0, turn: 0, up: 0, strafe: 0, lookYaw: 0, lookPitch: 0 },
  snapYaw: 0, // VR comfort snap-turn accumulator (radians)

  // Live positions of hero herds (written by Wildlife, read by Humans)
  herds: { elephants: [], donkeys: [] },

  // Live predator positions (hunters) + full fauna registry for the Field Guide
  predators: [],
  fauna: [], // [{ pos: Vector3, key: 'jaguar' }, ...]

  // Cinematic 'photo mode' override for hero captures (null | 'faultline' | 'aerial')
  photo: null,
  lowFX: false, // reduce particle load (auto quality-scaler / capture flag)

  // Behavioral ecosystem event bus
  breachX: 0, breachZ: 0, breachUntil: 0, breachSeq: 0, // whale breach → scatter + FX
  briefX: 0, briefT: 0, // zone being briefed → macaw echo circling
  dolphinMaxZ: -999, // nearest a sideliner dolphin gets to a bank → elephant wall

  // Postcard capture hook (registered by PostcardCapture inside the Canvas)
  capturePostcard: null,
};

if (typeof window !== 'undefined') window.__shared = shared;
